module.exports = __webpack_public_path__ + "media/configurations/ZOC_P-X-X-f29efa0e.png";